require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-anthony-urbano.json") })
        }
      }, "path---member-anthony-urbano");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-anthony-urbano!./.cache/json/member-anthony-urbano.json
// module id = 392
// module chunks = 231608221292675